// removed by extract-text-webpack-plugin
module.exports = {"font":"_3YDPf3ftQwH_pzS-A6OAQB","heading":"_2sirYBrgjBPXXUG5SqfVeP","size14":"_3M8HPC7KqnseMlEs0uQ-1R","size15":"LfGaAGzsQ-6ZTAkLmfWxQ"};


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/Footer/Font/style.css
// module id = 335
// module chunks = 37